import React, { FC, PropsWithChildren, useEffect } from 'react'
import SessionConnector from 'containers/Session'
import { Session } from 'types/User/Session'

type DisableContextMenuProps = {
  session: Session
}

const DisableContextMenu: FC<PropsWithChildren<DisableContextMenuProps>> = (props) => {
  const { children, session } = props
  const { isAdmin } = session

  const disableContextMenu = (ev: React.SyntheticEvent<HTMLElement>) => {
    if (isAdmin) {
      return true
    }

    // Only ADMINS have access to ContextMenu
    ev.preventDefault()
    return false
  }

  useEffect(() => {
    window.addEventListener('contextmenu', disableContextMenu)
    return () => {
      window.removeEventListener('contextmenu', disableContextMenu)
    }
  }, [isAdmin])
  return <>{children}</>
}

export default SessionConnector(DisableContextMenu)
